import { render, staticRenderFns } from "./WithdrawRecords.vue?vue&type=template&id=59a09c93&scoped=true"
import script from "./WithdrawRecords.vue?vue&type=script&lang=js"
export * from "./WithdrawRecords.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRecords.vue?vue&type=style&index=0&id=59a09c93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a09c93",
  null
  
)

export default component.exports